import React, { useState, useEffect } from "react";
import { fetchAllTariffCodes } from "../../medPracapi";
import Form from "react-bootstrap/Form";

function TariffSearch({ onTariffCodeSelect, practiceNumber }) {
  const [searchQuery, setSearchQuery] = useState("");
  const [tariffCodes, setTariffCodes] = useState([]); // ✅ Store all tariffs
  const [filteredResults, setFilteredResults] = useState([]); // ✅ Store filtered results
  const [selectedTariff, setSelectedTariff] = useState(null);

  useEffect(() => {
    async function loadTariffs() {
      console.log("PracticeNumber:", practiceNumber); // ✅ Log practice number
      const data = await fetchAllTariffCodes(practiceNumber); // ✅ Fetch all tariffs ONCE
      setTariffCodes(data); // ✅ Store all tariffs in state
    }
    loadTariffs();
  }, [practiceNumber]);

  useEffect(() => {
    if (searchQuery.trim() === "") {
      setFilteredResults([]); // ✅ Clear results when searchQuery is empty
      return;
    }

    // ✅ Search by code OR description (case insensitive)
    const results = tariffCodes.filter(
      (tariff) =>
        tariff.code.toLowerCase().includes(searchQuery.toLowerCase()) ||
        tariff.description.toLowerCase().includes(searchQuery.toLowerCase())
    );

    setFilteredResults(results);
  }, [searchQuery, tariffCodes]);

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const handleTariffClick = (tariff) => {
    setSelectedTariff(tariff);
    onTariffCodeSelect(tariff); // ✅ Send selected tariff to parent
    setSearchQuery("");
    setFilteredResults([]); // ✅ Clear search results
  };

  return (
    <div>
      <Form.Control
      id={`tariff-search-${Math.random()}`}
  name="tariffSearch"

        type="text"
        placeholder="Search by code or description"
        value={searchQuery}
        onChange={handleSearchChange}
        className="mb-3"
      />

      {filteredResults.length > 0 && (
        <div className="results-box">
          {filteredResults.map((tariff) => (
            <div
              key={tariff.code} // ✅ Use 'code' instead of 'tariffCode'
              className="result-item"
              onClick={() => handleTariffClick(tariff)}
              style={{ cursor: "pointer" }}
              onMouseEnter={(e) => {
                e.currentTarget.style.color = "#0F3490";
                e.currentTarget.style.fontWeight = "bold";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.color = "black";
                e.currentTarget.style.fontWeight = "normal";
              }}
            >
              {tariff.code} - {tariff.description} ({tariff.typeCode})
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default TariffSearch;
